export default {
  heading: "Experience"
};